"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resolve = resolve;
exports["default"] = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Cannot use lookbehind in regex because of safari
var EXPANSION_REGEX = /(\{)[^{]*(\})/g;
var DEFAULT_OPERATOR = {
  operator: '',
  separator: ',',
  named: false,
  ifEmpty: false
};
var OPERATORS = [{
  operator: '#',
  separator: ',',
  named: false,
  ifEmpty: false
}, {
  operator: '.',
  separator: '.',
  named: false,
  ifEmpty: false
}, {
  operator: '/',
  separator: '/',
  named: false,
  ifEmpty: false
}, {
  operator: ';',
  separator: ';',
  named: true,
  ifEmpty: false
}, {
  operator: '?',
  separator: '&',
  named: true,
  ifEmpty: true
}, {
  operator: '&',
  separator: '&',
  named: true,
  ifEmpty: true
}];

function getNamedOperatorIfNeeded(operator, varName, el) {
  if (operator.named) {
    return "".concat(varName, "=").concat(el);
  }

  return el;
}

function getValueFor(params, varName, operator) {
  return [].concat(params[varName]).reduce(function (acc, el) {
    return acc.concat(getNamedOperatorIfNeeded(operator, varName, el));
  }, []).join(operator.separator);
}

function containsParam(params, v, canBeEmpty) {
  if (canBeEmpty) {
    return Boolean(params && typeof params[v] !== 'undefined');
  }

  return Boolean(params && params[v]);
}

function startsWith(str, needle) {
  return str.indexOf(needle) === 0;
}

function getLinkOptions(link) {
  var groups = link.match(EXPANSION_REGEX);

  if (groups) {
    return {
      url: link,
      options: groups // need to slice of the surrounding '{' and '}' -> slice(1, -1)
      .reduce(function (acc, str) {
        return acc.concat(str.slice(1, -1).split(','));
      }, []).map(function (str) {
        if (OPERATORS.some(function (operator) {
          return startsWith(str, operator.operator);
        })) {
          return str.slice(1);
        }

        return str;
      })
    };
  }

  return {
    url: link,
    options: []
  };
}

function translateArgumentsWithOperator(str, params, operator) {
  return str.split(',').filter(function (v) {
    return containsParam(params, v, operator.ifEmpty);
  }).map(function (v) {
    return getValueFor(params, v, operator);
  }).join(operator.separator);
}

function translateTemplatedLink(link, params) {
  var groups = link.match(EXPANSION_REGEX);

  if (!groups) {
    return link;
  }

  return groups.reduce(function (returnLink, str) {
    // need to slice of the surrounding '{' and '}' -> slice(1, -1)
    var slicedStr = str.slice(1, -1);
    var matchedOperator = OPERATORS.find(function (operator) {
      return startsWith(slicedStr, operator.operator);
    });
    var operator = matchedOperator || DEFAULT_OPERATOR;

    if (!matchedOperator) {
      return returnLink.replace("{".concat(slicedStr, "}"), translateArgumentsWithOperator(slicedStr, params, operator));
    }

    var argumentList = translateArgumentsWithOperator(slicedStr.slice(1), params, operator);
    return returnLink.replace("{".concat(slicedStr, "}"), "".concat(argumentList.length > 0 ? operator.operator : '').concat(argumentList));
  }, link);
}

function translateLink(link, params) {
  if (!link.href) {
    return null;
  }

  if (link.templated) {
    return translateTemplatedLink(link.href, params);
  }

  return link.href;
}

function getMatchQuotient(options, params) {
  return params ? options.filter(function (option) {
    return option in params;
  }).length : 0;
}

function findBestTemplatedLinkForParams(linkList, params) {
  return linkList.map(function (mapLink) {
    return mapLink.href;
  }).filter(function (mapLink) {
    return mapLink;
  }).map(getLinkOptions).reduce(function (bestLink, currentLink) {
    var linkDescriptor = _objectSpread(_objectSpread({}, currentLink), {}, {
      matchQuotient: getMatchQuotient(currentLink.options, params)
    });

    if (!bestLink || linkDescriptor.matchQuotient > bestLink.matchQuotient) {
      return linkDescriptor;
    }

    return bestLink;
  }, null);
}

function translateArrayIntoLink(linkList, params) {
  if (!params) {
    var _link = linkList.find(function (linkCheck) {
      return !linkCheck.templated;
    });

    if (_link) {
      return translateLink(_link, params);
    }
  }

  var link = findBestTemplatedLinkForParams(linkList, params);
  return link ? translateTemplatedLink(link.url, params) : null;
}

function resolveLinksArray(links, linkName) {
  var link = links.find(function (item) {
    return item.rel === linkName;
  });
  return link && link.href || null;
}

function resolveNamedLink(link, params) {
  if (typeof link === 'string') {
    return link;
  } else if (link instanceof Array) {
    if (link.length > 0) {
      return translateArrayIntoLink(link, params);
    }
  } else if (link instanceof Object) {
    return translateLink(link, params);
  }

  return null;
}

function getObjectLinks(object) {
  return object._links || object.links || object;
}

function resolveLinksObject(object, linkName, params) {
  var links = getObjectLinks(object);

  if (links instanceof Array) {
    return resolveLinksArray(links, linkName);
  }

  if (links[linkName]) {
    return resolveNamedLink(links[linkName], params);
  }

  return null;
}

function resolve(object, linkName, params) {
  if (!linkName) {
    throw new Error('No link name was passed to hal link resolver');
  }

  return object ? resolveLinksObject(object, linkName, params) : null;
}

var _default = resolve;
exports["default"] = _default;